import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Poll @poll={{@model}}>\n  {{outlet}}\n</Poll>",{ moduleName: "@croodle/client/templates/poll.hbs" })